export default "__VITE_ASSET__o849wc7p__"